import { SITE_URL } from '~/utils';

const FALLBACKIMAGE = `${SITE_URL}/logo.png`;
const ALT_TEXT_ENTITY: { [key: string]: string } = {
  list: 'Saved List Preview',
  profile: 'Talent Profile Preview',
  content: 'Content Preview',
  mediaPack: 'Media Pack Preview',
  mediaKit: 'Media Kit Preview',
};

interface ogImage {
  url: string;
  alt: string;
  type: string;
}

export const processOgImages = (
  ogImagesURL: string[],
  entity: string,
): ogImage[] => {
  if (ogImagesURL.length === 0) {
    return [
      {
        url: FALLBACKIMAGE,
        alt: ALT_TEXT_ENTITY[entity],
        type: 'image/jpeg',
      },
    ];
  }

  return ogImagesURL.map((url) => ({
    url,
    alt: ALT_TEXT_ENTITY[entity],
    type: 'image/jpeg',
  }));
};
